import {
  dateFormatter,
  dateOrDateTimeFormatter,
  dateTimeFormatter,
  enumFormatter,
} from '../../utils/formatters';

const isLostTicketRow = row => row?.type === 'lost_ticket';

const pricingModeFormatter = (value, row) => {
  if (isLostTicketRow(row) || !value) {
    return '';
  }

  return value === 'tiered' ? 'Ступенчатый' : 'Фиксированный';
};

export const tariffColumns = [
  {
    dataField: 'is_active',
    text: 'Вкл/Выкл',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => (isLostTicketRow(row) && !row?.__lostTicketConfigured ? 'Не задан' : a ? 'Вкл' : 'Выкл'),
  },
  {
    dataField: 'start_time',
    text: 'Время начала',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'date-time-column',
  },
  {
    dataField: 'end_time',
    text: 'Время окончания',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'end-date-column',
  },
  {
    dataField: 'cost',
    text: 'Стоимость',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => (isLostTicketRow(row) && !row?.__lostTicketConfigured ? 'Не задан' : a),
  },
  {
    dataField: 'pricing_mode',
    text: 'Режим расчета',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: pricingModeFormatter,
  },
  {
    dataField: 'type',
    text: 'Тип тарифа',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => (isLostTicketRow(row) ? 'Штрафной билет' : enumFormatter(`tariff.type.${a}`, row?.type_label)),
  },
  {
    dataField: 'name',
    text: 'Наименование',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'vehicle_type',
    text: 'Тип ТС',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => (isLostTicketRow(row) || !a ? '' : enumFormatter(`vehicle.type.${a}`, row?.vehicle_type_label)),
  },
  {
    dataField: 'time_unit',
    text: 'Единицы измерения',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => (isLostTicketRow(row) || !a ? '' : enumFormatter(`time.unit.${a}`, row?.time_unit_label)),
  },
  {
    dataField: 'free_duration',
    text: 'Бесплатный период (сек)',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'day_types',
    text: 'Рабочие периоды',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => (a?.length ? a : []).map(i => enumFormatter(`tariff.date.type.${i}`)).join(', '),
  },
  {
    dataField: 'created_at',
    text: 'Создан',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
  {
    dataField: 'updated_at',
    text: 'Изменен',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
];

export const tariffPresetColumns = [
  {
    dataField: 'description',
    text: 'Описание',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'date',
    text: 'Дата',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'type',
    text: 'Вид дня',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => enumFormatter(`calendar.date.type.${a}`, row?.type_label),
  },
  {
    dataField: 'created_at',
    text: 'Создан',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
  {
    dataField: 'updated_at',
    text: 'Изменен',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
];

export const dailyTariffColumns = [
  {
    dataField: 'is_active',
    text: 'Вкл/Выкл',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => (a ? 'Вкл' : 'Выкл'),
  },
  {
    dataField: 'date',
    text: 'Дата',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateFormatter(a),
  },
  {
    dataField: 'start_time',
    text: 'Время начала',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'end_time',
    text: 'Время окончания',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'cost',
    text: 'Стоимость',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'pricing_mode',
    text: 'Режим расчета',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: pricingModeFormatter,
  },
  {
    dataField: 'type',
    text: 'Тип тарифа',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => enumFormatter(`tariff.type.${a}`, row?.type_label),
  },
  {
    dataField: 'vehicle_type',
    text: 'Тип ТС',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => enumFormatter(`vehicle.type.${a}`, row?.vehicle_type_label),
  },
  {
    dataField: 'time_unit',
    text: 'Единицы измерения',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: (a, row) => enumFormatter(`time.unit.${a}`, row?.time_unit_label),
  },
  {
    dataField: 'free_duration',
    text: 'Бесплатный период (сек)',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'created_at',
    text: 'Создан',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
  {
    dataField: 'updated_at',
    text: 'Изменен',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
];

export const addTariffColumns = [
  {
    dataField: 'id',
    text: 'ИД',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'id-column',
    hidden: true,
  },
  {
    dataField: 'description',
    text: 'Описание',
    disableSort: true,
    dataClassName: 'align-middle',
  },
];

export const addDailyTariffColumns = [
  {
    dataField: 'id',
    text: 'ИД',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'id-column',
    hidden: true,
  },
];
